/** Consultas compartidas entre features (TanStack Query sobre el cliente tipado). */
import { useQuery } from "@tanstack/react-query";
import { studio } from "./client";
import { retryEvery30s } from "./retry";
import { useBibliotecaDe, useCuadernoDe, useFichaDe, useTelemetriaDe } from "./biblioteca";

export { retryEvery30s };

export const useMe = () => useQuery({ queryKey: ["me"], queryFn: studio.me, staleTime: 5 * 60_000 });
/** `enabled=false`: con el rol de biblioteca el Shell no pide lo que la puerta de rol le niega. */
export const useSkills = (enabled = true) => useQuery({ queryKey: ["skills"], queryFn: studio.skills, enabled, ...retryEvery30s });
/** Telemetría real por skill (30 d por defecto). Consulta APARTE del catálogo:
 *  si el motor de trazas cae, el catálogo se sigue viendo (solo los números faltan). */
export const useSkillsTelemetria = () => useQuery({ queryKey: ["skills", "telemetria"], queryFn: () => studio.skillsTelemetria(), ...retryEvery30s });
export const useEngagements = (enabled = true) => useQuery({ queryKey: ["engagements"], queryFn: studio.engagements, enabled, ...retryEvery30s });

/** La biblioteca (ADR-14), atada al cliente real; las vistas usan las de `datos.ts` con el cliente por props. */
export const useBiblioteca = (enabled = true) => useBibliotecaDe(studio.biblioteca, enabled);
export const useCuaderno = (code: string | undefined) => useCuadernoDe(studio.biblioteca, code);
export const useFicha = (slug: string) => useFichaDe(studio.biblioteca, slug);
/** «Uso en el Despacho» (ADR-20 pt 4): los contadores sin casa, con su reintento cada 30 s. */
export const useTelemetriaBiblioteca = () => useTelemetriaDe(studio.telemetriaBiblioteca);
